import { RadioButtonStateType, } from '@kubit/web-ui-components/radioButtonGroup/types';
import { commonStyles, disabledCommonStyles, errorCommonStyles } from '../commonStyles';
import { RadioButtonGroupVariantType } from '../variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [RadioButtonGroupVariantType.REGULAR]: {
            [RadioButtonStateType.DEFAULT]: {
                ...commonStyles(FOUNDATIONS, FONT),
                radioButton: {
                    ...commonStyles(FOUNDATIONS, FONT).radioButton,
                    background_color: FOUNDATIONS.color_comp_forms_radiobutton_unselected_bg,
                },
            },
            [RadioButtonStateType.SELECTED]: {
                ...commonStyles(FOUNDATIONS, FONT),
                radioButton: {
                    ...commonStyles(FOUNDATIONS, FONT).radioButton,
                    border_width: FOUNDATIONS.border_100,
                    border_color: FOUNDATIONS.color_accent_selected_border_50,
                    background_color: FOUNDATIONS.color_comp_forms_radiobutton_selected_bg,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    background_color: FOUNDATIONS.color_accent_selected_icon_50,
                },
            },
            [RadioButtonStateType.DISABLED]: {
                ...disabledCommonStyles(FOUNDATIONS, FONT),
                label: {
                    ...disabledCommonStyles(FOUNDATIONS, FONT).label,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
            },
            [RadioButtonStateType.DISABLED_SELECTED]: {
                ...disabledCommonStyles(FOUNDATIONS, FONT),
                radioButton: {
                    ...disabledCommonStyles(FOUNDATIONS, FONT).radioButton,
                    border_width: FOUNDATIONS.border_100,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    background_color: FOUNDATIONS.color_accent_disabled_icon_50,
                },
                label: {
                    ...disabledCommonStyles(FOUNDATIONS, FONT).label,
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
            },
            [RadioButtonStateType.ERROR]: {
                ...errorCommonStyles(FOUNDATIONS, FONT),
            },
            [RadioButtonStateType.ERROR_SELECTED]: {
                ...errorCommonStyles(FOUNDATIONS, FONT),
                radioButton: {
                    ...errorCommonStyles(FOUNDATIONS, FONT).radioButton,
                    border_width: FOUNDATIONS.border_100,
                },
                icon: {
                    ...errorCommonStyles(FOUNDATIONS, FONT).icon,
                    background_color: FOUNDATIONS.color_feedback_error_icon_50,
                },
            },
        },
    };
};
//# sourceMappingURL=regular.js.map